// ===========================================================================
// ProCare.SG — static page copy
// ---------------------------------------------------------------------------
// Structural content that belongs to the design of the pages themselves — the
// customer journey, service bundles, page FAQs. Managed content (projects,
// blog articles, testimonials) lives in Firestore and is loaded through
// src/services/api.js.
// ===========================================================================

export const JOURNEY_STEPS = [
    {
        n: "01",
        title: "Plan the Move",
        desc: "Tell us your timeline, property type and what needs doing.",
        icon: "ClipboardList",
    },
    {
        n: "02",
        title: "Prepare the Property",
        desc: "Dismantling, disposal and clearing to get the space ready.",
        icon: "PackageOpen",
    },
    {
        n: "03",
        title: "Fix and Improve",
        desc: "Repairs, painting and handyman works to restore condition.",
        icon: "Wrench",
    },
    {
        n: "04",
        title: "Clean and Restore",
        desc: "Deep cleaning and floor polishing for a spotless finish.",
        icon: "Sparkles",
    },
    {
        n: "05",
        title: "Move In or Hand Over",
        desc: "A move-in ready, handover-ready property, cared for.",
        icon: "Home",
    },
];

export const WHO_WE_HELP = [
    {
        title: "Property Agents",
        icon: "BadgeCheck",
        desc: "Prepare listings, handovers and newly completed homes with one reliable service partner.",
    },
    {
        title: "Homeowners",
        icon: "Home",
        desc: "Move, refresh and maintain your home without juggling multiple contractors.",
    },
    {
        title: "Landlords",
        icon: "KeyRound",
        desc: "Turn units around quickly between tenancies with cleaning, repairs and painting.",
    },
    {
        title: "Tenants",
        icon: "Users",
        desc: "Move in and move out smoothly with cleaning, disposal and defect touch-ups.",
    },
    {
        title: "Businesses",
        icon: "Building2",
        desc: "Office moves, cleaning and maintenance handled with minimal downtime.",
    },
    {
        title: "Property Managers",
        icon: "ClipboardCheck",
        desc: "One coordinated team for the recurring care of the properties you manage.",
    },
];

export const WHY_CHOOSE = [
    {
        title: "One-Stop Convenience",
        desc: "Moving, cleaning, painting, repairs and more, all under one roof.",
    },
    {
        title: "One Point of Contact",
        desc: "A single dedicated contact who coordinates the entire job.",
    },
    {
        title: "Experienced Service Team",
        desc: "A capable team that understands residential and commercial work.",
    },
    {
        title: "Clear, Transparent Quotes",
        desc: "Straightforward quotations based on the services you need.",
    },
    {
        title: "Residential & Commercial",
        desc: "From HDB flats and condos to offices and retail spaces.",
    },
    {
        title: "Coordinated Around Your Move",
        desc: "Work scheduled and sequenced to fit your moving timeline.",
    },
];

export const HOW_IT_WORKS = [
    {
        n: "01",
        title: "Tell Us What You Need",
        desc: "Contact ProCare.SG through WhatsApp or the enquiry form.",
    },
    {
        n: "02",
        title: "Site Assessment",
        desc: "Arrange a site visit or simply submit photos and project details.",
    },
    {
        n: "03",
        title: "Receive a Quotation",
        desc: "Get a clear quotation based on the services required.",
    },
    {
        n: "04",
        title: "We Handle the Work",
        desc: "We schedule, coordinate and complete the agreed work.",
    },
];

export const BUNDLES = [
    {
        slug: "move-out-ready",
        name: "Move-Out Ready",
        desc: "Everything to leave your old place in top condition.",
        items: ["Moving", "Disposal", "Cleaning", "Painting touch-ups", "Minor repairs"],
        popular: false,
    },
    {
        slug: "move-in-ready",
        name: "Move-In Ready",
        desc: "Walk into a fresh, cared-for new home.",
        items: ["Deep cleaning", "Painting", "Aircon servicing", "Handyman installation", "Floor polishing"],
        popular: true,
    },
    {
        slug: "property-handover-care",
        name: "Property Handover Care",
        desc: "Hand over your unit with confidence.",
        items: ["Defect repairs", "Cleaning", "Painting", "Dismantling", "Disposal"],
        popular: false,
    },
    {
        slug: "agent-listing-prep",
        name: "Agent Listing Preparation",
        desc: "Make every listing show its best.",
        items: ["Cleaning", "Painting", "Repairs", "Floor polishing", "Property touch-ups"],
        popular: false,
    },
];

export const SERVICE_FAQS = [
    { q: "How do I get a quote?", a: "Message us on WhatsApp or submit the contact form with your property details. We'll respond with a clear quotation." },
    { q: "Do you handle both residential and commercial properties?", a: "Yes. We work across HDB flats, condominiums, landed homes, offices and retail spaces." },
    { q: "Can I bundle multiple services together?", a: "Absolutely. Bundling moving, cleaning, painting and repairs is what we do best — one team, one contact." },
    { q: "Which areas of Singapore do you serve?", a: "We serve properties across Singapore. Share your location and we'll confirm scheduling." },
];
